import React from 'react';
import { useSelector } from 'react-redux';
import { UseFormReset } from 'react-hook-form/dist/types/form';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Separator } from '../../../../../CommonComponents/OPL/Separator/Separator';
import { useResetAssetBucketsMutation } from '../../api/useResetAssetBucketMutation';
import { toast } from '../../../../../CommonComponents/OPL/Toast/Toast';
import { FormFieldValues } from '../../AssetBucketing.meta';
import { useResetAdvisorAssetBucketsMutation } from '../../api/useResetAdvisorAssetBucketMutation';
import { selectHasAdvisorAssetBucketingLayoutAccess } from '../../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  resetForm?: UseFormReset<FormFieldValues>;
}

export const Header: React.FC<Props> = ({ resetForm }) => {
  const hasAdvisorAssetBucketingLayoutAccess = useSelector(
    selectHasAdvisorAssetBucketingLayoutAccess,
  );

  const {
    mutateAsync: resetAssetBuckets,
    isLoading: isResettingAssetBuckets,
  } = useResetAssetBucketsMutation();

  const {
    mutateAsync: resetAdvisorAssetBuckets,
    isLoading: isResettingAdvisorAssetBuckets,
  } = useResetAdvisorAssetBucketsMutation();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="8">
        <Text as="h2" fontWeight={600} color="neutral.600" fontSize="h4">
          Page Layout & Content
        </Text>

        <Button
          variant="link"
          isLoading={isResettingAssetBuckets || isResettingAdvisorAssetBuckets}
          disabled={isResettingAssetBuckets || isResettingAdvisorAssetBuckets}
          onClick={async () => {
            try {
              const defaultAssetBuckets = hasAdvisorAssetBucketingLayoutAccess
                ? await resetAdvisorAssetBuckets()
                : await resetAssetBuckets();

              if (resetForm) {
                resetForm(defaultAssetBuckets);
              }
            } catch {
              toast.error('Sorry, something went wrong. Please try again.');
            }
          }}
        >
          Reset to Default Layout & Content
        </Button>
      </Box>
      <Separator />
    </>
  );
};
